<template>
    <div class="leader-page-header-top" :style="{ backgroundColor: backgroundColor }">
        <template v-if="touch">
            <div class="back-icon" v-if="showBack" @click="routerGo">
                <img src="../../../../assets/image/index/back-icon.png" alt srcset />
            </div>
        </template>
        <div class="index-menu-icon" v-if="isIndex">
            <img src="../../../../assets/image/mainIndex/title_bg.png" alt srcset />
            <div class="index-title">{{ title }}</div>
        </div>
        <div class="menu-icon" v-else>
            <img src="../../../../assets/image/index/menu-icon.png" alt srcset />
            <div style="color: #fff;">{{ title }}</div>
        </div>
        <div class="info-wrap">
            <BottomInHeader :menuType="menuType"></BottomInHeader>
            <div class="warn-icon">
                <img
                    class="logout1"
                    src="../../../../assets/image/index/warn-header.png"
                    alt
                    @click="onWarnClick()"
                />
            </div>
            <el-dropdown
                v-if="userInfo.user_type != 99"
                class="dropdown-class"
                @command="handleCommand"
            >
                <div class="username-class">
                    <img
                        v-if="!touch"
                        class="logout1"
                        src="../../../../assets/image/index/username.png"
                        alt
                    />
                    <p class="usernametext">{{ userInfo.user_name }}</p>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="m">修改密码</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <div v-else class="dropdown-class">
                <div class="username-class">
                    <img
                        v-if="!touch"
                        class="logout1"
                        src="../../../../assets/image/index/username.png"
                        alt
                    />
                    <p class="usernametext">{{ userInfo.user_name }}</p>
                </div>
            </div>
            <div class="warn-icon">
                <img
                    class="logout1"
                    @click="logout"
                    src="../../../../assets/image/index/logout.png"
                    alt
                    v-show="can_logout == 1"
                />
            </div>
        </div>
        <!-- </span> -->
        <!-- <div class="title-wrap" id="openWindow" v-show="!screenShow" @click="fullScreen">
            <div class="title-h2">{{ title }}</div>
            <div class="title-h3">{{ subTitle }}</div>
        </div>
        <div class="title-wrap" v-show="screenShow" @click="fullScreenOut">
            <div class="title-h2">{{ title }}</div>
            <div class="title-h3">{{ subTitle }}</div>
        </div> -->
        <reset-pwd :isVisible.sync="isVisible" :showClose="true"></reset-pwd>
    </div>
</template>
<script>
import ResetPwd from "../../../layout/reset-pwd";
import BottomInHeader from "./leader-page-bottom-inHeader.vue";
export default {
    components: {
        ResetPwd,
        BottomInHeader
    },
    props: {
        menuType: String,
        title: String,
        showTem: Boolean,
        subTitle: String,
        showBack: Boolean,
        isIndex: Boolean,
        backType: {
            type: String,
            default: "index"
        },
        backgroundColor: String
    },
    data() {
        return {
            tempVisible: false,
            screenShow: false,
            body: null,
            element: null,
            isVisible: false,
            can_logout: true
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.login.userInfo;
        },
        humitureInfo() {
            return this.$store.state.index.humitureInfo;
        },
        touch() {
            return this.$store.state.index.touch;
        }
    },
    watch: {
        touch() {
            return this.$store.state.index.touch;
        }
    },
    methods: {
        /**
         * 用户名hover下拉菜单点击回调
         * params {String} 菜单名
         */
        handleCommand(command) {
            // 修改密码
            if (command === "m") {
                this.isVisible = true;
            }
        },
        onWarnClick() {
            sessionStorage.setItem('header-title','周期离线统计');
            this.$router.push("/alarm_event_offline");
        },
        controlFun() {
            if (
                document.body.scrollHeight === window.screen.height &&
                document.body.scrollWidth === window.screen.width
            ) {
                this.screenShow = true;
            } else {
                this.screenShow = false;
            }
        },
        fullScreen() {
            this.element.classList.add("container_full_element");
            let rfs =
                this.body.requestFullScreen ||
                this.body.webkitRequestFullScreen ||
                this.body.mozRequestFullScreen ||
                this.body.msRequestFullScreen,
                wscript;
            if (typeof rfs != "undefined" && rfs) {
                rfs.call(this.body);
                return;
            }
            if (typeof window.ActiveXObject != "undefined") {
                wscript = new ActiveXObject("WScript.Shell");
                if (wscript) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        fullScreenOut() {
            this.element.classList.remove("container_full_element");
            let exitMethod =
                document.exitFullscreen || //W3C
                document.mozCancelFullScreen || //FireFox
                document.webkitExitFullscreen || //Chrome等
                document.webkitExitFullscreen; //IE11
            if (exitMethod) {
                exitMethod.call(document);
            } else if (typeof window.ActiveXObject !== "undefined") {
                //for Internet Explorer
                let wscript = new ActiveXObject("WScript.Shell");
                if (wscript !== null) {
                    wscript.SendKeys("{F11}");
                }
            }
        },
        logout() {
            this.$confirm("确定退出此系统吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.$message({
                        type: "success",
                        message: "退出成功!",
                        dangerouslyUseHTMLString: true
                    });
                    sessionStorage.clear();
                    // this.$router.push("/home");
                    this.$router.push("/login");
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消退出操作"
                    });
                });
        },
        showTempDialog() {
            console.log();
            this.tempVisible = true;
        },
        routerGo() {
            if (this.backType == "index") {
                if (this.touch) {
                    this.$router.replace("/index?touch=true");
                } else {
                    this.$router.replace("/index");
                }
            } else {
                this.$router.go(-1);
            }
        }
    },
    mounted() {
        this.body = document.getElementsByTagName("body")[0];
        this.element = document.getElementsByTagName("body")[0];
        this.can_logout = sessionStorage.getItem("can_logout");
        window.addEventListener("resize", this.controlFun);
    }
};
</script>
<style lang="scss">
.leader-page-header-top {
    height: 3.5rem;
    // height: 135px;
    // height: 7rem;
    border-bottom: 1px solid #136b8f;
    margin-bottom: 1rem;
    width: 100%;
    z-index: 3;
    // background-image: url("../../../../assets/image/index/top.png");
    // background-repeat: no-repeat;
    // background-position: top center;
    // background-size: auto 100%;
    position: relative;
}
.info-wrap {
    position: absolute;
    right: px2Rem(10px);
    top: px2Rem(20px);
    height: px2Rem(40px);
    line-height: px2Rem(40px);
   // width: 50%;
    text-align: right;
    display: flex;
    flex-flow: row nowrap;
    .warn-icon {
        display: block;
        // position: absolute;
        // top: px2Rem(15px);
        // right: px2Rem(20px);
        cursor: pointer;
        margin-right: px2Rem(20px);
    }
    .logout1 {
        width: px2Rem(30px) !important;
        height: px2Rem(30px) !important;
        border-radius: 0 !important;
    }
    .el-dropdown-menu {
        border: 1px solid #56fcff;
        background-color: #0b1929;

        .el-dropdown-menu__item {
            color: #56fcff !important;
            &:hover {
                background-color: #0b1929;
            }
        }
    }
    .el-dropdown {
        display: flex !important;
        align-items: center !important;
    }
    .dropdown-class {
        cursor: pointer;
        // position: absolute;
        // top: 1rem;
        // right: 4rem;
        // height: px2Rem(80px);
        // line-height: px2Rem(80px);
        margin-right: px2Rem(20px);

        .username-class {
            display: flex;
            justify-content: space-between;
        }
        .usernametext {
            color: #56fcff;
            margin-left: 10px;
            font-size: px2Rem(16px);
            height: px2Rem(30px);
            line-height: px2Rem(30px);
        }
    }
    .logout {
        cursor: pointer;
        width: px2Rem(30px) !important;
        height: px2Rem(30px) !important;
        border-radius: 0 !important;
        // position: absolute;
        // top: 1rem;
        // right: 2rem;
    }
}

.title-wrap {
    width: 100%;
    // height: 100px;
    height: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title-h2 {
        text-align: center;
        letter-spacing: 10px;
        font-size: 1.7rem;
        font-weight: 500;
        color: #56fcff;
        // line-height: 60px;
    }
    .title-h3 {
        text-align: center;
        letter-spacing: 5px;
        font-size: 1.3rem;
        font-weight: 500;
        color: #56fcff;
        margin-top: 0.5rem;
    }
}

.top span img {
    width: 2.6rem;
    height: 2.6rem;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
}
.top span {
    position: absolute;
    right: 0;
    top: 12px;
    color: #56fcff;
    font-size: 1rem;
    font-weight: bold;
}
.top span b {
    padding-left: 30px;
    padding-right: 30px;
}
.lov {
    position: absolute;
    left: 20px;
    top: 20px;
    color: #fff;
    font-size: 20px;
}
.logout {
    cursor: pointer;
    width: 1.8rem !important;
    height: 1.8rem !important;
    border-radius: 0 !important;
    position: absolute;
    top: 1rem;
    right: 2rem;
}

.back-icon {
    position: absolute;
    top: 1rem;
    left: 2rem;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    img {
        width: 100%;
        height: 100%;
    }
}
.menu-icon {
    position: absolute;
    top: 50%;
    left: 1.5rem;
    transform: translate(0, -50%);
    cursor: pointer;
    display: inline-flex;
    align-items:center;
    font-size: 0.8rem;
    img {
        width: 1rem;
        height: 1rem;
        margin-right: 0.2rem;
    }
}
.index-menu-icon {
    height: 100%;
    width: 100%;
    // background: url("../../../../assets/image/mainIndex/title_bg.png") no-repeat;
    // background-size: 100% 100%;
    position: relative;
    img {
        width: 90%;
        height: 100%;
    }
    .index-title {
        color: #fff;
        position: absolute;
        left: 1rem;
        top: 50%;
        font-size: 1.3rem;
        transform: translate(0, -50%)
    }
}
.notify-msg {
    border: 1px solid #56fbff;
    background: #121e31;
    height: 20rem;
    margin: 0;
    padding: 0;
    width: 24rem;
    .el-notification__closeBtn {
        color: #56fbff !important;
    }
    .el-notification__group {
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    .notify-msg-box {
        margin: 0;
        padding: 0;
        width: 24rem;
        font-size: 0.8rem;
        .notify-msg-top {
            border-bottom: 1px solid #56fbff;
            margin: 1rem 1.3rem;
            .notify-msg-title {
                font-weight: 550;
                font-size: 1rem;
                color: #56fbff;
                text-align: center;
            }
            .notify-msg-subtitle {
                padding: 0.3rem 0;
                position: relative;
                .sub_title {
                    text-align: center;
                    color: #fff;
                }
                .sub_more {
                    position: absolute;
                    right: 0;
                    top: 0.3rem;
                    color: #56fbff;
                    cursor: pointer;
                }
                .alarm_times {
                    color: #ff6e6e;
                }
            }
            .notify-msg-context {
                padding-top: 0.5rem;
                color: #666666;
                cursor: pointer;
            }
        }
        .notify-dotted-border {
            border-bottom: 1px dotted #56fbff;
        }
        .notify-msg-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            display: flex;
            color: #fff;
            margin: 0 1.3rem 0.3rem 1.3rem;
            padding-bottom: 0.3rem;
            .msg-time {
                width: 4.5rem;
            }
            .msg-content {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
            }
            .msg-state {
                width: 4.5rem;
                text-align: right;
                cursor: pointer;
            }
            .msg-deal {
                color: #56fbff;
            }
            .msg-ndeal {
                color: #ff6e6e;
            }
            .msg-icon {
                margin-left: 0.5rem;
                .image {
                    width: auto;
                    height: 1.1rem;
                }
            }
        }
    }
}
</style>
